require('slick-carousel');

const moreBookingsCarousel = require('../components/moreBookingsCarousel').moreBookingsCarousel;

new moreBookingsCarousel();